import { A9Service } from 'components/system/angular';
import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system/data-provider';

import { CustomerCardAdd, RsCustomerCard, RsCustomerCardInfo, CustomerCardUpdate } from './types';

export interface ICustomerCardsDataProvider extends IDataProviderV2<RsCustomerCard, RsCustomerCardInfo, CustomerCardAdd, CustomerCardUpdate> {
    generateReport(params): Promise<any>;
}

@A9Service('customerCardsDataProvider')
export class CustomerCardsDataProvider
    extends AbstractDataProviderV2<RsCustomerCard, RsCustomerCardInfo, CustomerCardAdd, CustomerCardUpdate>
    implements ICustomerCardsDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/cards');
    }

    public patch(): Promise<null> {
        return Promise.reject('Patch method is not supported for CustomerCardsDataProvider');
    }

    public generateReport(params) {
        const url = `middle://rs/customers/${params.customerId}/cards/${params.id}/report`;
        return this.service.updateRequest(url, 'PUT', params.data);
    }
}
